import { motion } from 'framer-motion';
import './local.scss';

export default function Location() {
  const handleGoogleMaps = () => {
    window.open('https://www.google.com/maps/dir//Av.+%C3%81lvares+Cabral,+894+-+Lourdes,+Belo+Horizonte+-+MG', '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="location" id="localizacao">
      <div className="container">
        <motion.div 
          className="location-header"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="section-title">Estamos em Lourdes – fácil de chegar</h2>
          <p className="section-subtitle">📌 Av. Álvares Cabral, 894 – Lourdes, Belo Horizonte – MG</p>
        </motion.div>

        <div className="location-content">
          <motion.div 
            className="location-map"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3750.5!2d-43.9447!3d-19.9386!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDU2JzE5LjAiUyA0M8KwNTYnNDEuMCJX!5e0!3m2!1spt-BR!2sbr!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Localização Eco Lavanderia Express"
            ></iframe>
          </motion.div>

          <motion.div 
            className="location-info"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >

            <button onClick={handleGoogleMaps} className="location-btn">
              <i className="ri-map-pin-line"></i>
              Abrir rota no Google Maps agora
            </button>
            <div className="info-card">
              <div className="info-icon">
                <i className="ri-map-pin-line"></i>
              </div>
              <div className="info-content">
                <h4>Endereço</h4>
                <p>Av. Álvares Cabral, 894<br />Lourdes, Belo Horizonte - MG</p>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon">
                <i className="ri-phone-line"></i>
              </div>
              <div className="info-content">
                <h4>Telefone / WhatsApp</h4>
                <p>(31) 99990-1010</p>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon">
                <i className="ri-time-line"></i>
              </div>
              <div className="info-content">
                <h4>Horário de Funcionamento</h4>
                <p>Segunda a Domingo<br />6h às 23h</p>
              </div>
            </div>

            <div className="location-highlights">
              <h4>Pontos de Referência</h4>
              <ul>
                <li>
                  <i className="ri-shopping-bag-3-line"></i>
                  <span>Próximo ao Minas Shopping</span>
                </li>
                <li>
                  <i className="ri-truck-line"></i>
                  <span>Delivery na região</span>
                </li>
                <li>
                  <i className="ri-road-map-line"></i>
                  <span>Fácil acesso pela Av. Álvares Cabral</span>
                </li>
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
